import { nextTick } from "vue";
import { useThemeImgUrl } from "@/hooks/useImage";
import DOMPurify from "dompurify";
import { HashOnly } from "./hash";
import { errorReportUpload } from "@/api";
export * from "./uuid";
//判断是否为手机端
export const isMobile = () => {
	let flag = true;
	if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
		flag = true;
	} else if (/(Android)/i.test(navigator.userAgent)) {
		flag = true;
	} else if (window.innerWidth < 600) {
		flag = true;
	} else {
		flag = false;
	}
	return flag;
};
export const getUrlParams = (key: string): string | null => {
	const href = location.href;
	const index = href.indexOf("?");
	let val: string | null = null;
	if (index !== -1) {
		const str = href.substring(index + 1);
		const arr = str.split("&");
		for (let i = 0; i < arr.length; i++) {
			const arrItem = arr[i].split("=");
			// setCookie(arrItem[0], arrItem[1])
			if (arrItem[0] === key) {
				val = arrItem[1];
				break;
			}
		}
	}
	return val;
};
/**
 * 输入框过滤标签和特殊处理
 * @param content
 * @param isDeSpace
 */
export const dealTextCon = (content: string, isDeSpace = false) => {
	content = content
		.replace(/&(?!amp;|lt;|gt;|quot;|#039;)/g, "&amp;") // 替换 &，但保留已转义的实体
		.replace(/<(?!br\s*\/?>)/g, "&lt;") // 替换 <，但保留 <br> 标签
		.replace(/>/g, "&gt;") // 替换 >
		.replace(/"/g, "&quot;") // 替换 "
		.replace(/'/g, "&#039;"); // 替换 ';
	content = DOMPurify.sanitize(content, {
		ALLOWED_TAGS: ["br", "#text"],
		ALLOWED_ATTR: [],
	});
	if (isDeSpace) {
		content = content.replace(/\s/g, "");
	}
	return content;
};
//显示文本消息处理（可能包含emoji字符）
export const viewTextMsg = (str: any, replaceXss: boolean = false) => {
	if (str != undefined && typeof str === "string") {
		if (!replaceXss) {
			str = dealTextCon(str);
		}
		str = str.replace(
			/\[emoticon_(.*?)\]/gi,
			`<img class="w-6 h-6 inline-block" src="${useThemeImgUrl("emoji/emoticon_$1_gif.gif")}" alt="[emoticon_$1]" />`
		);
		str = str.replace(/\r?\n/g, "<br/>");
		return str;
	} else {
		return "";
	}
};

export const getSelection = (sendInput: any) => {
	nextTick(() => {
		const getSelection = window.getSelection || document.getSelection;
		const range = getSelection() as any; // 创建range
		range.selectAllChildren(sendInput.value); // range 选择notesDom下所有子内容
		range.collapseToEnd(); // 光标移至最后
	});
};

export const formatSize = (size: number): string => {
	const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
	const _size = size ? Math.log(size) : 0;
	const index = Math.floor(_size / Math.log(1024));
	const newSize = size / Math.pow(1024, index);
	const strSize = index > 1 ? newSize.toFixed(2) : Math.floor(newSize);
	return `${strSize} ${units[index]}`;
};

// get file suffix type
export const getFileSuffix = (url: string) => {
	if (!url) return null;
	const filename = url.substring(url.lastIndexOf("/") + 1);
	return filename.substring(filename.lastIndexOf(".") + 1);
};
/**
 * 处理分割数据 对数据赋值默认值
 * @param timestamp
 */
export const timeStampPB2Date = (timestamp: any) => {
	if (!timestamp || !timestamp.seconds || !timestamp.seconds.mul) {
		// 这块需要约定一个 出错的 默认值, 或者魔法值
		return timestamp;
	}
	try {
		return new Date(
			timestamp.seconds
				.mul(1e3)
				.add(timestamp.nanos / 1e6)
				.toNumber()
		);
	} catch {
		return new Date();
	}
};
/**
 * 判断是否long类型
 * @param {any} obj
 */
export function longValue(obj: any): any {
	try {
		return obj.toString();
	} catch (e) {
		return obj;
	}
}
/**
 * 去除对象空值
 * paramRemove
 * @param data
 */
export const paramRemove = (data: any) => {
	Object.keys(data).forEach((item) => {
		if (isEmpty(data[item])) {
			delete data[item];
		}
	});
	return data;
};
/**
 * 去除对象空值
 * @param obj
 * @param
 * isEmpty
 * paramRemove
 */
export const isEmpty = (obj: any) => {
	return typeof obj === "undefined" || obj === null || obj === "";
};
/**
 * 拼接 baseUrl 和 path 形成完整的 URL
 * 示例正则表达式，用于验证 URL 格式
 * @param baseUrl
 */
export const isValidUrl = (baseUrl: string) => {
	const regexPattern = /^(https?|ftp):\/\/.*\.(m3u8||pdf|js|jpg|jpeg|png|gif|bmp|webp|mp4|mov|wmv|avi|mkv)$/i;
	const regex = new RegExp(regexPattern);
	return regex.test(baseUrl);
};

export const acceptLimitsType = {
	image: ["image/png", "image/jpeg", "image/bmp", "image/gif", "image/x-ms-bmp"],
	video: ["video/mp4", "video/x-msvideo", "video/webm", "video/vnd.sealedmedia.softseal.mov", "video/quicktime", "video/x-flv", "video/x-ms-wmv"],
	doc: [
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/pdf",
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"text/csv",
	],
};

/**
 * 将对象转换为 URLSearchParams
 * @param obj - 要转换的对象
 * @param prefix - 可选的键前缀，用于处理嵌套对象
 * @returns URLSearchParams
 */
export function toUrlSearchParams(obj: Record<string, any>, prefix: string = ""): URLSearchParams {
	const params = new URLSearchParams();

	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		const paramKey = prefix ? `${prefix}[${key}]` : key;

		if (Array.isArray(value)) {
			value.forEach((item) => params.append(paramKey, item));
		} else if (typeof value === "object" && value !== null) {
			const nestedParams = toUrlSearchParams(value, paramKey);
			nestedParams.forEach((v, k) => params.append(k, v));
		} else if (value !== undefined && value !== null) {
			params.append(paramKey, value);
		}
	});

	return params;
}

/**
 * 获取特定url参数key 的值
 * @param key string
 * @returns string
 */
export const getUrlParamsVal = (key: string): string | null => {
	const params = new URLSearchParams(window.location.search);
	if (params) {
		return params.get(key) ? params.get(key) : "";
	}
	return "";
};
/**
 * 判读是不是NG棋牌
 */
export const isNGqp = () => {
	try {
		const params = getUrlParamsVal("custom"); // 解码 URL 编码
		if (params) {
			const isNil = (value: any) => {
				return value == null; // 同时处理 null 和 undefined
			};
			const isFlag = (obj: any) => {
				if (typeof obj !== "object") return false;
				for (const i in obj) {
					if (isNil(obj[i])) return false;
				}
				return true;
			};
			const decodedStr = decodeURIComponent(params);
			// 替换单引号为双引号
			const jsonStr = decodedStr.replace(/‘/g, '"').replace(/’/g, '"').replace(/'/g, '"');
			// 解析为对象
			const obj = JSON.parse(jsonStr);
			// console.log("ddd", obj, isNil(obj?.chatId));
			// console.log("toUrlSearchParams", toUrlSearchParams(obj).get("id"));
			if (isFlag(obj) && obj?.hash === HashOnly.merchant1) {
				return {
					...obj,
				};
			}
		}
	} catch (e) {
		return false;
	}
	return false;
};
export const isShowBackIcon = () => {
	const params = getUrlParamsVal("back"); // 解码 URL 编码
	if (params) {
		return params;
	}
	return false;
};

const tagRegex = /<\/?[a-zA-Z][\w-]*(\s+[a-zA-Z_:][\w:.-]*(\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s]+))?)*\s*\/?>/i;

export function isValidHtmlTag(tag: string) {
	return tagRegex.test(tag);
}

// 自定义错误上报方法
export function startReportError(errorData: { code: number; payload: string }) {
	// 发送到后端日志服务
	errorReportUpload({ data: [{ ...errorData, url: window.location.href, platform: "Platform_H5", createdAt: new Date().toISOString() }] })
		.then(() => {
			console.log("上报成功");
		})
		.catch((err) => {
			console.error(" 上报时出错了: ", err);
		});
}
